<template>
  <component
    :is="baseTag"
    v-if="isActive"
    v-bind="bindings"
    id="banner"
    class="sticky"
  >
    <Transition
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-4"
      leave-active-class="transform transition ease-out duration-300 "
    >
      <div v-if="isActive" class="relative z-50 flex w-full items-center">
        <section class="container relative flex items-center">
          <slot name="body">
            <div
              class="flex flex-wrap items-center justify-center space-x-2 text-center text-md"
            >
              <CMSText
                :blok="blok?.fields.body ?? null"
                class="font-sans font-medium"
              />

              <CMSContentfulLink
                v-if="blok?.fields.links?.fields.ctaUrl"
                :to="blok?.fields.links?.fields?.ctaUrl"
                class="text-md text-orange-500 underline"
              >
                {{ blok?.fields.links?.fields?.label }}
              </CMSContentfulLink>
              <SFCountdown
                v-if="blok?.fields.countdownUntil && isCountdownActive"
                class="w-full grow items-center justify-center text-center font-sans text-md sm:w-auto sm:grow-0 sm:text-left"
                :time-until="blok?.fields.countdownUntil"
              />
            </div>
          </slot>
        </section>
      </div>
    </Transition>
  </component>
</template>

<script setup lang="ts">
import { computed, resolveComponent } from 'vue'
import type { CMSBannerProps } from '../types'
import CMSText from './Text.vue'
import CMSContentfulLink from './ContentfulLink.vue'
import { SFCountdown } from '#storefront-ui/components'

const { blok } = defineProps<CMSBannerProps>()

const isCountdownActive = computed(() => {
  return (
    blok?.fields.countdownUntil &&
    new Date(blok?.fields.countdownUntil).getTime() > new Date().getTime()
  )
})

const isActive = computed(() => {
  return Object.values(blok || {}).length === 0 ? true : blok?.fields.isActive
})

const cachedUrl = computed(() => blok?.fields.ctaUrl)

const baseTag = computed(() => {
  return cachedUrl.value ? resolveComponent('CMSContentfulLink') : 'div'
})

const bindings = computed(() => {
  return cachedUrl.value ? { to: cachedUrl.value } : {}
})

defineOptions({ name: 'CMSBanner' })
</script>
